import { useEffect, useRef } from 'react';
import { useWrapper } from '../Context/WrapperContext';

export default function useFocusControl(isActiveCondition: (index: number) => boolean) {
  const ref = useRef<HTMLDivElement>(null);
  const { index } = useWrapper();

  useEffect(() => {
    if (ref.current) {
      const isActive = isActiveCondition(index);
      const elements = ref.current.querySelectorAll("input, button, textarea, select, a");
      
      elements.forEach(el => {
        if (el instanceof HTMLElement) {
          el.tabIndex = isActive ? 0 : -1;
        }
      });
    }
  }, [index, isActiveCondition]);

  return ref;
}
